import Unbxd from "./Unbxd";
import {SearchPaginationContextProvider} from "@/pages/search/searchHooks/SearchPaginationContext";

const SearchRenderer = () => {

    return <SearchPaginationContextProvider>
        <Unbxd/>
    </SearchPaginationContextProvider>;
};

export default SearchRenderer;
